import { render, staticRenderFns } from "./ContentBlockHeader.vue?vue&type=template&id=7745b65b&scoped=true"
import script from "./ContentBlockHeader.vue?vue&type=script&lang=js"
export * from "./ContentBlockHeader.vue?vue&type=script&lang=js"
import style0 from "./ContentBlockHeader.vue?vue&type=style&index=0&id=7745b65b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7745b65b",
  null
  
)

export default component.exports